import { useLocalIntegration } from './store'

/**
 * Function for get default integration value on parse search request schema
 *
 * @author Ivan Shchedrovskyi
 */
export const getSearchDefaultIntegration = () => {
	const integrationNames = useLocalIntegration.getState().integrations

	return integrationNames.map(integrationName => ({
		integrationName
	}))
}
